// const SERVER_IP = "localhost:8080";
//PROD

//const SERVER_IP = "api.backoffice.lac-net.net";
const SERVER_IP = "api-backoffice.lacnet.com";

export const ENV ={
    //PROD
    BASE_PATH: `https://${SERVER_IP}`,
    // BASE_PATH: `http://${SERVER_IP}`,
    API_ROUTES: {
        //USER//
        REGISTER: "/user",
        USER: "/user",
        USERS: "/user",
        USER_ME: "/user/me",
        APPROVE_USER: "/approve",
        //------//
        //LOGIN//
        LOGIN: "/login",
        REFRESH_ACCESS_TOKEN: "/refreshToken",
        //------//
        //MARKET//
        MARKETS: "/markets",
        MARKET: "/markets",
        APPROVE: "/approve",
        //------//
        //REQUEST//
        REGISTRATION: "/registration",
        REQUEST_REGISTRATION: "/request-registration",
        
        //------//
        //ADMIN_PERMISSION//
        PERMISSIONS: "/registration",
        PERMISSION: "/registration",
        APPROVE_PERMISSION: "/approve",
        OTP_PERMISSION: "/otp",
        //------//
        //NODES//
        NODES: "/node",
        NODE: "/node",
        APPROVE_NODE: "/approve",
        EXCEL_NODE: "/node-excel",
        //------//
    },
    JWT: {
        ACCESS_TOKEN: "accessToken",
        REFRESH_TOKEN: "refreshToken"
    }
};